/**
 * ButtonListSettings - список кнопок с добавлением/удалением
 */
import React from 'react';
import Icon from '../../../components/AppIcon';
import ButtonSettings from './ButtonSettings';

export default function ButtonListSettings({
  buttons = [],
  onChange,
  allSections = [],
  allPages = [],
  maxButtons = 5,
  title = 'Кнопки',
  variants = ['primary', 'outline'],
  defaultButton = {
    text: 'Новая кнопка',
    variant: 'outline',
    link: '#'
  },
}) {
  const addButton = () => {
    if (buttons.length >= maxButtons) return;
    onChange([
      ...buttons,
      {
        id: Date.now().toString(),
        ...defaultButton,
      }
    ]);
  };

  const updateButton = (index, updatedButton) => {
    const newButtons = [...buttons];
    newButtons[index] = updatedButton;
    onChange(newButtons);
  };

  const removeButton = (index) => {
    onChange(buttons.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-semibold text-sm text-text-secondary uppercase tracking-wider">
          {title}
        </h3>
        {buttons.length < maxButtons && (
          <button
            onClick={addButton}
            className="flex items-center gap-1 text-sm text-primary hover:text-primary/80 transition-colors"
          >
            <Icon name="Plus" size={16} />
            Добавить
          </button>
        )}
      </div>

      {buttons.map((button, index) => (
        <ButtonSettings
          key={button.id || index}
          button={button}
          index={index}
          onChange={(updated) => updateButton(index, updated)}
          onRemove={() => removeButton(index)}
          allSections={allSections}
          allPages={allPages}
          variants={variants}
        />
      ))}

      {buttons.length === 0 && (
        <p className="text-sm text-text-secondary text-center py-4">
          Нет кнопок. Нажмите "Добавить" чтобы создать.
        </p>
      )}
    </div>
  );
}
